module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/rule_frame-7910634a6514fd7dc92c37cf53a47cfe.png";